<template>
    <div id="videoContent">
        <h5-video @ready="playerReadied" @nodePlayEnd="nodePlayEnd" v-if="videoPath" class="vjs-custom-skin"
                  :video-path="videoPath"
                  :start-time="timeStamp.startTime" :end-time="timeStamp.endTime"/>
    </div>
</template>
<script>
  import H5Video from '@/components/H5Video';
  import { $Cookies, timeFormat } from '@/utils';
  import { getRscH5Video } from '@/api/player';


  export default {
    name: 'VideoPlayers',
    components: {
      H5Video
    },
    props: {
      rscId: {
        type: String,
        required: true
      },
      timeStamp: {
        type: Object,
        required: true
      },
      orderNum: {
        type: Number,
        default: 1
      }
    },
    data () {
      return {
        videoPath: '',
        $player: null
      };
    },
    watch: {
      timeStamp: async function () {
        const me = this;
        if (me.videoPath) {
          const sTime = timeFormat(me.timeStamp.startTime);
          me.$player.currentTime = sTime;
          me.$player.play();
        }
      }
    },
    async created () {
      const uid = $Cookies.get('uid') || '0';
      await getRscH5Video({
        rscID: this.rscId,
        userNo: Number(uid)
      }).then(data => {
        if (data.success) {
          const { url } = data.result;
          this.videoPath = url;
        } else {
          this.$message.error(data.errorMsg);
        }
      });
    },
    methods: {
      nodePlayEnd: function () {
        this.$emit('vFinishPlay', this.orderNum);
      },
      playerReadied (player) {
        this.$player = player;
        const me = this;
        player.addEventListener('loadedmetadata', function () {
          const sTime = timeFormat(me.timeStamp.startTime);
          player.currentTime = sTime;
          player.play();
        });
      }

    }
  };
</script>
